/**
 * Finance & profitability BI (`fin.*`): margin, profitability, receivables, forecasts.
 * Sections live in `./analytics-finance/*`; every `xxxEn` is typed against its `xxxPl`, so a missing key is a compile error.
 */
import { marginEn, marginPl } from './analytics-finance/margin';
import { profitEn, profitPl } from './analytics-finance/profit';
import { recEn, recPl } from './analytics-finance/receivables';
import { fcEn, fcPl } from './analytics-finance/forecasts';
type Shape<T> = { [K in keyof T]: T[K] extends string ? string : Shape<T[K]> };

export const finPl = {
  state: {
    forbidden: 'Brak dostępu do tego widoku',
    forbiddenHint: 'Twoja rola nie ma uprawnień do tych danych. Skontaktuj się z administratorem.',
    notFound: 'Dane nie są jeszcze dostępne',
    notFoundHint: 'Ten raport nie zwrócił wyniku. Spróbuj ponownie za chwilę lub zmień filtry.',
    error: 'Nie udało się pobrać danych',
    errorHint: 'Sprawdź połączenie i spróbuj ponownie.',
  },
  kpi: {
    sales: 'Sprzedaż',
    margin: 'Marża (zł)',
    marginPct: 'Marża %',
    corrections: 'Korekty (KOR)',
    correctionsShare: 'Udział korekt: {value} sprzedaży',
    realProfit: 'Zysk rzeczywisty',
    realProfitPct: 'Rentowność %',
  },
  ...marginPl,
  ...profitPl,
  ...recPl,
  ...fcPl,
};

export const finEn: Shape<typeof finPl> = {
  state: {
    forbidden: 'No access to this view',
    forbiddenHint: 'Your role is not allowed to see this data. Contact your administrator.',
    notFound: 'Data is not available yet',
    notFoundHint: 'This report returned nothing. Try again in a moment or change the filters.',
    error: 'Could not load the data',
    errorHint: 'Check your connection and try again.',
  },
  kpi: {
    sales: 'Sales',
    margin: 'Margin (PLN)',
    marginPct: 'Margin %',
    corrections: 'Corrections (credit notes)',
    correctionsShare: 'Corrections: {value} of sales',
    realProfit: 'Real profit',
    realProfitPct: 'Profitability %',
  },
  ...marginEn,
  ...profitEn,
  ...recEn,
  ...fcEn,
};
